export const styles = ({ typography, palette }) => ({
  tooltip: {
    fontSize: typography.caption.fontSize,
    background: palette.tooltip,
    color: palette.white,
  },
});
